<template>
  <div class="content-wrapper configurator-menu">
    <div class="arrow-container show-xs">
      <a href="#" class="arrow-left-wrapper" @click="$emit('go-back')">
        <img src="/arrow-left.png" alt="">
      </a>
      <a href="#" class="arrow-right-wrapper" @click="$emit('go-next')">
        <img src="/arrow-right.png" alt="">
      </a>
    </div>

    <ul>
      <li
        class="uppercase"
        v-for="(item, index) in menuItems"
        v-bind:key="index"
        :class="{ active: currentStep == item }"
      >
        <a
          @click="clickMenu(item, index)"
          :class="{ active: currentStep == item }"
          href="#"
          >{{ getItemName(item) }}
          <span class="show-xs">({{index+1}} of {{menuItems.length}})</span>
          <img
            v-if="isCompleted(item) && false"
            src="/configurator/ok-icon.png"
            alt=""
            style="width: 15px; margin-left: 4px"
           />
        </a>
      </li>
    </ul>
    <div class="container">
        <div class="show-xs mobile-sub-menu">
          <div class="price-wrapper">
            <h3>&euro;{{price}}<a href="#asterisc">*</a></h3>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "configurator-menu",
  data() {
    return {};
  },
  props: ["menuItems", "currentStep", "results", "price"],
  methods: {
    clickMenu: function (item, index) {
      this.$emit("set-element", item, index);
    },
    getItemName: function (item) {
      return item
        .replaceAll("-", " ")
        .replace("saddle and tape", "saddle & tape")
        .replace("cages bottles", "bottle cages")
        .replace("tyres", "tires");
    },
    isCompleted: function (item) {
      if (item == "bars") {
        item = "handlebars";
      } else if (item == "cages-bottles") {
        item = "cagebottle";
      } else if (item == "saddle-and-tape") {
        item = "saddle";
      }

      let checkVar = this.results[item];

      if (item == "frame") {
        checkVar = this.results.frame.finish;
      }
      if (item == "personal-title") {
        return (
          typeof this.results.frame.title.family != "undefined" &&
          this.results.frame.title.family != null &&
          typeof this.results.frame.title.text != "undefined" &&
          this.results.frame.title.text != null
        );
      }
      if (item == "colour") {
        return (
          typeof this.results.colour.primaryColor != "undefined" &&
          this.results.colour.primaryColor != null &&
          typeof this.results.colour.secondaryColor != "undefined" &&
          this.results.colour.secondaryColor != null
        );
      }
      if (item == "groupset") {
        return (
          typeof this.results.groupset != "undefined" &&
          this.results.groupset != null &&
          typeof this.results.crankset != "undefined" &&
          this.results.crankset != null
        );
      }

      return typeof checkVar != "undefined" && checkVar != null;
    },
  }
};
</script>

<style lang="scss" scoped>
.configurator-menu {
  ul {
    margin-bottom: 24px;
    padding-left: 0;
    display: flex;
    justify-content: space-between;
    li {
      list-style: none;
      a {
        font-size: 10px;
        font-stretch: normal;
        letter-spacing: 1.92px;
        color: #000;
        text-transform: uppercase;
        font-weight: 500;
        text-decoration: none;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 0.0625rem;
          background: #000;
          transition: all .3s ease-in-out;
        }
        &:hover {
          &:after {
            width: 100%;
          }
        }
        &.active {
          color: black;
          text-decoration: none;
          &::after {
            content: "";
            width: 100%;
            border-bottom: 1px solid black;
            position: absolute;
            left: 0;
            bottom: -1px;
          }
        }
      }
    }
  }
  .mobile-sub-menu {
    text-align: right;
    margin-top: 50px;
    width: 100%;
  }
}
</style>

